<div class="flex flex-col xs:gap-[24px] justify-start items-start">
  <highcharts-chart
    [options]="chartOptions"
    [Highcharts]="highCharts"
    [update]="updateFlag | async"
    (updateChange)="updateFlag.next($event)"
  ></highcharts-chart>
  <div
    class="time-phase flex flex-row gap-[8px] justify-start items-center xs:items-start"
    *ngFor="let timePhase of timePhasesToShow; index as i"
  >
    <span class="counter">{{ i + 1 }}.</span>
    <div class="flex flex-row xs:flex-col gap-[8px] justify-start items-center xs:items-start">
      <mat-form-field *ngIf="isModeSelector" class="mode" mat-select-height-medium data-at-mode>
        <mat-select
          data-at-mode-select
          [ngModel]="
            diagnosticsVddStartStopTempService.getStructure(timePhase, semanticValues.ENUMCHOICE)
              .value
          "
          (selectionChange)="onModeChange($event.value, i)"
          [disabled]="!isVddEditable || isParameterRunning"
          gtm="onOpen"
          gtmAction="Open mode dropdown"
          gtmCategory="diagnosticsPage"
          fieldTextContentTooltip
        >
          <mat-option
            data-at-option
            *ngFor="let mode of getModes(i)"
            attr.option="option-{{ mode }}"
            [value]="mode"
            gtm="onSelect"
            gtmAction="Mode: '{{ mode }}'"
            gtmCategory="diagnosticsPage"
            fieldTextContentTooltip
          >
            {{ mode }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-row gap-[8px] justify-start items-center">
        <mat-form-field mat-select-height-medium data-at-start>
          <mat-label>{{
            'DIAGNOSTICS.EDIT_START_STOP_TIME.LABEL.START_TIME' | translate
          }}</mat-label>
          <mat-select
            data-at-start-select
            [ngModel]="
              diagnosticsVddStartStopTempService.getTimeValueFromStructure(
                diagnosticsVddStartStopTempService.getStructure(timePhase, semanticValues.STARTTIME)
              )
            "
            (selectionChange)="onStartTimePhaseChange($event.value, i)"
            [disabled]="!isVddEditable || isParameterRunning"
            gtm="onOpen"
            gtmAction="Open start time dropdown"
            gtmCategory="diagnosticsPage"
            fieldTextContentTooltip
          >
            <mat-option
              data-at-option
              *ngFor="
                let time of diagnosticsVddStartStopTempService.getStartTimes(
                  timePhase,
                  timeType.StopTime
                )
              "
              attr.option="option-{{ time }}"
              [value]="time"
              gtm="onSelect"
              gtmAction="Start time: '{{ time }}'"
              gtmCategory="diagnosticsPage"
              fieldTextContentTooltip
            >
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>-</span>
        <mat-form-field mat-select-height-medium data-at-stop>
          <mat-label>{{
            'DIAGNOSTICS.EDIT_START_STOP_TIME.LABEL.STOP_TIME' | translate
          }}</mat-label>
          <mat-select
            data-at-stop-select
            [ngModel]="
              diagnosticsVddStartStopTempService.getTimeValueFromStructure(
                diagnosticsVddStartStopTempService.getStructure(timePhase, semanticValues.STOPTIME)
              )
            "
            (selectionChange)="onStopTimePhaseChange($event.value, i)"
            [disabled]="!isVddEditable || isParameterRunning"
            gtm="onOpen"
            gtmAction="Open stop time dropdown"
            gtmCategory="diagnosticsPage"
            fieldTextContentTooltip
          >
            <mat-option
              data-at-option
              *ngFor="let time of diagnosticsVddStartStopTempService.getStopTimes(timePhase)"
              attr.option="option-{{ time }}"
              [value]="time"
              gtm="onSelect"
              gtmAction="Stop time: '{{ time }}'"
              gtmCategory="diagnosticsPage"
              fieldTextContentTooltip
            >
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-icon
        *ngIf="isVddEditable"
        class="delete-time-phase-icon"
        [class.disabled]="isParameterRunning"
        gtm="onRemoveTimePhase"
        (click)="onTimePhaseDelete(i)"
        >delete</mat-icon
      >
    </div>
  </div>

  <div
    *ngIf="diagnosticsVddStartStopTempService.isMaxNumberOfTimePhasesReached"
    class="error flex flex-row gap-[8px] justify-start items-center"
  >
    <mat-icon>error</mat-icon>
    <div>{{ 'DIAGNOSTICS.EDIT_START_STOP_TIME.ERROR.TIME_PHASES_LIMIT' | translate }}</div>
  </div>

  <div
    *ngIf="isVddEditable && timePhasesToShow?.length < maxNumberOfTimePhases"
    gtm="onOpen"
    gtmAction="Add Time Phase dialog"
    gtmCategory="diagnosticsPage"
    class="add-time-phase-btn flex flex-row gap-[4px] justify-start items-center"
    [class.disabled]="isParameterRunning"
    (click)="openAddTimePhaseModal()"
  >
    <span *ngIf="timePhasesToShow?.length === 0"
      >{{ 'DIAGNOSTICS.EDIT_START_STOP_TIME.BUTTON.ADD_FIRST_TIME_PHASE' | translate }}
    </span>
    <span *ngIf="timePhasesToShow?.length !== 0"
      >{{ 'DIAGNOSTICS.EDIT_START_STOP_TIME.BUTTON.ADD_TIME_PHASE' | translate }}
    </span>
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
